import { objectToUrlParams } from 'utils/params';
import BaseResource from './BaseResource';
import OrganizationResource from './OrganizationResource';

export default class OrganizationsResource extends BaseResource {
  constructor() {
    super({ url: '/api/organisations' });
  }

  list(params = { role: 'member', s: 100, o: 'name', f: '' }) {
    const urlParams = objectToUrlParams(params);
    return super
      .get({ url: `${this.url}${urlParams}` })
      .then((response) => response)
      .catch((error) => error.response);
  }

  create(data, params) {
    const urlParams = objectToUrlParams(params);
    return super
      .post(data, { url: `${this.url}${urlParams}` })
      .then((response) => response)
      .catch((error) => error.response);
  }

  organization(id) {
    return new OrganizationResource(`${this.url}/${id}`);
  }
}
